



















































import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { NormsServices } from '../api/NormsServices';
import Loading from 'vue-loading-overlay';
import jsZip from 'jszip';
import { saveAs } from 'file-saver';
import { generateZipFile } from '../index';

@Component({
    components: {
        Loading
    }
})
export default class DownloadFilesDialog extends Vue {
    @Prop() visible: boolean;
    @Prop() files: object;
    @Prop() msgGeneratingDatabase: string;
    @Prop() fileName: string;
    @Prop() msg: string;
    @Prop() idNewDatabase: boolean;
    formStatus: boolean = false;
    downloadingDatabase: boolean = false;
    downloadingNames: boolean = false;

    @Emit()
    closeModal() {}

    @Emit()
    backToList() {}

    mounted() {}

    get getDatabaseStatus() {
        if (Object.keys(this.files).length === 0) {
            return false;
        } else {
            return true;
        }
    }

    downloadFiles() {
        this.setLoadingDb(true);
        let folderName = this.idNewDatabase + '-' + this.fileName + '.zip';
        let files = {
            'Database.txt': this.files['database_txt'],
            'Names.txt': this.files['names_txt']
        };
        generateZipFile(folderName, files, true);
        setTimeout(() => {
            this.setLoadingDb(false);
        }, 500);
    }

    setLoadingDb(val) {
        this.downloadingDatabase = val;
    }

    setLoadingNm(val) {
        this.downloadingNames = val;
    }

    download(filename, text) {
        text = text.replace(/([^\r])\n/g, '$1\r\n');
        let element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }
}
